import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

// Browser/Mobile
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

class Images extends Component {

  constructor(props){
    super(props);

    this.state = {
      fullScreen: false,
      goBig: false,
    };
  }

  setEvent(value) {

    this.setState({
      fullScreen: value,
    })
  }

  _onUpdate(event) {
    console.log(event)
    if (event == null){

    } else {

    }
  }

  _renderFullscreenButton(onClick, isFullscreen) {

   return (
     <button
       type='button'
       className={
         `image-gallery-fullscreen-button${isFullscreen ? ' active' : ''}`}
       onClick={() => {

         this.setState({
           goBig: !isFullscreen,
         })

         onClick();

       }}
     />
   );
  }

   _renderItem(item) {
     if (this.state.goBig){
       return (
         <div className='image-gallery-image'>
           <img
               src={item.original}
               style={{ width: '100%', height: 600, objectFit: 'contain' }}
           />
         </div>
       )
     } else {
       return (
         <div className='image-gallery-image'>
           <img
               src={item.original}
               style={{ width: '100%', height: 200, objectFit: 'contain' }}
           />
         </div>
       )
     }
   }

  _renderFullScreenItem(item){
    return (
      <div className='image-gallery-image'>
        <img
            src={item.original}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  _renderThumbInner(item) {
    return (
      <div className='image-gallery-image'>
        <img
            src={item.thumbnail}
            style={{ width: '100%', height: 40, objectFit: 'contain' }}
        />
      </div>
    )
  }

  render(){
    const { classes, theme, location, data } = this.props;

    let imagesArray= [];

    if (!data["Pic1"]) {

      imagesArray.push({"original": "", "thumbnail": ""})
      let images = {
        images: [
          imagesArray
        ]
      }

      return(
        <div className={classes.container}>
        <div>
          <Typography> No Images Available</Typography>
        </div>
        <ImageGallery
          showNav={false}
          items={imagesArray}
          infinite={true}
          disableArrowKeys={true}
          renderItem={this._renderItem}
          renderThumbInner={this._renderThumbInner}
        />
      </div>
      );

    } else {
      let pic1 = data["Pic1"];
      let pic2 = data["Pic2"];
      let pic3 = data["Pic3"];
      let pic4 = data["Pic4"];
      let pic5 = data["Pic5"];
      let pic6 = data["Pic6"];
      let pic7 = data["Pic7"];
      let pic8 = data["Pic8"];
      let pic9 = data["Pic9"];
      let pic10 = data["Pic10"];
      let pic11 = data["Pic11"];
      let pic12 = data["Pic12"];
      let pic13 = data["Pic13"];
      let pic14 = data["Pic14"];
      let pic15 = data["Pic15"];
      let pic16 = data["Pic16"];
      let pic17 = data["Pic17"];
      let pic18 = data["Pic18"];
      let pic19 = data["Pic19"];
      let pic20 = data["Pic20"];
      let pic21 = data["Pic21"];
      let pic22 = data["Pic22"];
      let pic23 = data["Pic23"];
      let pic24 = data["Pic24"];
      let pic25 = data["Pic25"];
      let pic26 = data["Pic26"];

      if (pic1 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic1;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic2 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic2;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic3 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic3;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic4 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic4;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic5 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic5;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic6 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic6;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic7 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic7;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic8 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic8;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic9 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic9;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic10 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic10;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic11 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic11;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic12 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic12;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic13 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic13;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic14 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic14;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic15 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic15;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic16 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic16;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic17 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic17;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic18 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic18;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic19 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic19;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic20 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic20;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic21 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic21;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic22 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic22;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic23 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic23;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic24 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic24;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic25 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic25;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }

      if (pic26 != null) {
        let image_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + pic26;
        imagesArray.push({"original": image_url, "thumbnail": image_url})
      }


      let images = {
        images: [
          imagesArray
        ]
      }

      return(
        <div className={classes.container}>
          <BrowserView>
            <ImageGallery
              ref={i => this._imageGallery = i}
              sizes={"50x50"}
              showNav={false}
              items={imagesArray}
              infinite={true}
              disableArrowKeys={true}
              renderItem={this._renderItem.bind(this)}
              renderThumbInner={this._renderThumbInner.bind(this)}
              renderFullscreenButton = {this._renderFullscreenButton.bind(this)}
              showFullscreenButton={true}
            />
          </BrowserView>
          <MobileView>
            <ImageGallery
              sizes={"50x50"}
              showNav={false}
              items={imagesArray}
              infinite={true}
              disableArrowKeys={true}
              renderItem={this._renderItem.bind(this)}
              renderThumbInner={this._renderThumbInner}
            />
          </MobileView>
      </div>
      );
    }
  }
}

/*
<Slider settings={settings} className={classes.container}>
  {data.images.map(tile => (
    <img className={classes.imageContent} src={tile.img} />
  ))}
</Slider>
*/

export default withRouter(withStyles(styles, { withTheme: true })(Images));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/components/Images/index.js